// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6690":"60c939ec","7291":"60c939ec"}[chunkId] + ".chunk.css";
};